import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

const DataItemRadio = ({
                         label,
                         id,
                         type = 'radio',
                         fieldName,
                         checked,
                         onChange,
                         customContainerStyle = '',
                         customLabelStyle = '',
                         customInputStyle = '',
                         customBoxStyle = '',
                         disabled
                       }) => {
  return (
    <div
      className={classnames('d-inline-block', {'opacity-30': disabled}, customContainerStyle)}
    >
      <input
        type={type}
        className={classnames('hide-checkbox', styles.input, customInputStyle)}
        id={id}
        name={fieldName}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={classnames(`custom-checkbox mb-0 custom-checkbox-size`, customBoxStyle)}
      >
        <span
          className={classnames(`text-nowrap`, customLabelStyle)}
        >
          {label}
        </span>
      </label>
    </div>
  );
};

export const DataItemRadioFixed = ({
                                     label,
                                     id,
                                     customContainerStyle = '',
                                     customLabelStyle = '',
                                     customInputStyle = '',
                                     customBoxStyle = '',
                                     disabled,
                                     ...rest
                                   }) => {
  return (
    <div
      className={classnames('d-inline-block', {'opacity-30': disabled}, customContainerStyle)}
    >
      <input
        id={id}
        type="radio"
        className={classnames('hide-checkbox', styles.input, customInputStyle)}
        disabled={disabled}
        {...rest}
      />
      <label
        htmlFor={id}
        className={classnames(`custom-checkbox mb-0 custom-checkbox-size`, customBoxStyle)}
      >
        <span
          className={classnames(`text-nowrap`, customLabelStyle)}
        >
          {label}
        </span>
      </label>
    </div>
  );
};

export default DataItemRadio;
